import Work1 from "../../assets/farm.png";
import Work2 from "../../assets/hotel.png";
import Work3 from "../../assets/movie.png";
import Work4 from "../../assets/currency.png";

const Menu = [
  {
    id: 1,
    image: Work1,
    title: "Farm-Trade",
    category: ["Frontend", "Next JS"],
    repositoryUrl: "#",
  },
  {
    id: 2,
    image: Work2,
    title: "Hotela",
    category: ["Frontend",],
    url: "https://hotel-site-one-sigma.vercel.app/",
    repositoryUrl: "https://github.com/Bhankid/Hotel-Site.git",
  },
  {
    id: 3,
    image: Work3,
    title: "Movie Suggestion Site",
    category: ["Frontend", "React"],
    url: "https://my-movie-site-nine.vercel.app/",
    repositoryUrl: "https://github.com/Bhankid/MovieSuggestionSite.git",
  },
  {
    id: 4,
    image: Work4,
    title: "Currency Converter",
    category: ["Backend", "Java"],
    url: "#",
    repositoryUrl: "https://github.com/Bhankid/CurrencyConverterApp.git",
  },
];

export default Menu;
